/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PctTypeOfPay {
    ACTUAL_BONUS_PCT = 'actualBonusPct',
    TARGET_BONUS_PCT = 'targetBonusPct',
    LTI_ACTUAL_PCT = 'ltiActualPct',
    LTI_TARGET_PCT = 'ltiTargetPct',
    SALES_INCENTIVE_PCT_ACTUAL = 'salesIncentivePctActual',
    SALES_INCENTIVE_PCT_TARGET = 'salesIncentivePctTarget',
    SALES_COMMISSION_TARGET_PCT = 'salesCommissionTargetPct',
}
